module.exports = __webpack_public_path__ + "img/Management.727f977a.svg";